import React from 'react';
import { subscribe } from 'react-contextual';
import { Container, Row, Col, Progress, Button } from 'reactstrap';
import Tag from '../../tag';
import onClickHandle from '../onClickHandle';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const ProgramHighlightPanel = ({
                           className, heading, nonprofit, description, needed, completed, size, image1, tags, partnerImage, link
                       }) => (

    <Container className="panel-padding">
        <Row className={className}>
            <Col {...size.left} className="gi-campaign-image d-flex">
                <img src={`${config.cdnUrl}${image1}`} alt={heading} className="gi-background-image" />
                {partnerImage && <img className="partner-ngo-image" src={`${config.cdnUrl}${partnerImage}`} alt={heading} />}
            </Col>
            <Col {...size.right} className="gi-campaign-textbox d-flex justify-content-between f-d-col">
                <div className="campaign-panel-top">
                    <div className="tag-row">
                        {typeof tags !== 'undefined' ? tags.map((tag, index) => <Tag {...tag} key={index} />) : []}
                    </div>
                    <h3>{heading}</h3>
                    <p>{`by ${nonprofit}`}</p>
                    <p>{description}</p>
                </div>
                <div className="progress-wrapper">
                    <a href={link} onClick={(e) => onClickHandle(e, 'campaign-givenow-click', { heading , link }, link)}>
                        <Button color="primary" className="btn-full-width campaign-panel-givenow">
                            give now
                        </Button>
                    </a>
                </div>
            </Col>
        </Row>
    </Container>
);

ProgramHighlightPanel.defaultProps = {
    className: 'gi-campaign-panel d-flex',
    heading: 'Help underprivileged women earn a living',
    nonprofit: 'Ola Foundation',
    description: 'Ola Foundation works towards skilling women women to earn an income, teach them financial literacy to save more money and equipping them with emotional intelligence to better manage their hardships in life.',
    size: {
        left: {
            xs: 12,
            sm: 12,
            md: '7',
            lg: '7',
            xl: '7',
        },
        right: {
            xs: 12,
            sm: 12,
            md: '5',
            lg: '5',
            xl: '5',
        },
    },
    tags: [
        {
            type: 'extremeneed',
            design: 'capsule',
        },
    ],
    image1: '/static/images/home/ola/ola-help-underprivileged-women-earn-a-living.jpg',
    partnerImage: '',
    link: '/program/Empower-Women-to-Build-a-Better-Future'
};

export default subscribe()(ProgramHighlightPanel);
